import {
    type IDynamicLinkedServiceTypeMetadata,
    type ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { LinkedServiceDynamicLoaderService } from 'app/registries/linked-service/linked-service-dynamic-loader.service';
import { GlobalVariables } from 'app/services/globals';
import { DataflowFormatDynamicLoaderService } from 'app/registries/dataflow/dataflow-format-dynamic-loader.service';
import { DatasetDynamicLoaderService } from 'app/registries/dataset/dataset-dynamic-loader.service';
import { azureDataLakeStoreCosmosStructuredStreamFileDatasetMetadata } from 'app/registries/dataset/azure-datalakestore-cosmosstructuredstream-metadata';
import {
    type IDatasetTypeMetadata,
    type IDynamicDatasetTypeMetadata
} from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adobeExperiencePlatformDatasetMetadata } from 'app/registries/dataset/adobe-experience-platform-object.metadata';
import { amazonMWSObjectMetadata } from 'app/registries/dataset/amazon-mws-object-metadata';
import { amazonRdsForOracleDatasetMetadata } from 'app/registries/dataset/amazon-rds-for-oracle-metadata';
import { amazonRdsSqlServerDatasetMetadata } from 'app/registries/dataset/amazon-rds-sql-server-table-metadata';
import { genericCDataTableMetadata } from 'app/registries/dataset/generic-cdata-table-metadata';
import { amazonRedshiftTableMetadata } from 'app/registries/dataset/amazon-redshift-table-metadata';
import { amazonS3DatasetMetadata } from 'app/registries/dataset/amazon-s3-metadata';
import { avroMetadata } from 'app/registries/dataset/avro-metadata';
import { azureBlobFSDatasetMetadata } from 'app/registries/dataset/azure-blob-fs-metadata';
import { azureDataExplorerTableMetadata } from 'app/registries/dataset/azure-data-explorer-table-metadata';
import { azureDatabricksDeltaLakeDatasetMetadata } from 'app/registries/dataset/azure-databricks-delta-lake-dataset-metadata';
import { databricksDatasetMetadata } from 'app/registries/dataset/databricks-dataset-metadata';
import { azureDataLakeStoreFileDatasetMetadata } from 'app/registries/dataset/azure-datalakestorefile-metadata';
import { azureDataLakeStoreGen2CosmosStructuredStreamFileDatasetMetadata } from 'app/registries/dataset/azure-datalakestoregen2-cosmosstructuredstream-metadata';
import { azureMariaDBTableMetadata } from 'app/registries/dataset/azure-maria-db-table-metadata';
import { azureMySqlTableMetadata } from 'app/registries/dataset/azure-mysql-table-metadata';
import { azurePostgreSqlTableMetadata } from 'app/registries/dataset/azure-postgre-sql-table-metadata';
import { azureHorizonDbTableMetadata } from 'app/registries/dataset/azure-horizon-db-table-metadata';
import { azureSearchIndexMetadata } from 'app/registries/dataset/azure-search-index-metadata';
import { azureSqlMITableMetadata } from 'app/registries/dataset/azure-sql-mi-table-metadata';
import { azureTableMetadata } from 'app/registries/dataset/azure-table-metadata';
import { azureBlobDatasetMetadata } from 'app/registries/dataset/azureblob-metadata';
import { azureSqlDatasetMetadata } from 'app/registries/dataset/azuresql-metadata';
import { azureSqlDWDatasetMetadata } from 'app/registries/dataset/azuresqldw-metadata';
import { binaryMetadata } from 'app/registries/dataset/binary-metadata';
import { cassandraTableMetadata } from 'app/registries/dataset/cassandra-table-metadata';
import { icebergMetadata } from 'app/registries/dataset/iceberg-metadata';
import { commonDataServiceEntityMetadata } from 'app/registries/dataset/common-data-service-entity-metadata';
import { concurObjectMetadata } from 'app/registries/dataset/concur-object-metadata';
import { cosmosDbCollectionMetadata } from 'app/registries/dataset/cosmos-db-collection-metadata';
import { cosmosDbMongoDbApiCollectionMetadata } from 'app/registries/dataset/cosmos-db-mongodb-api-collection-metadata';
import { couchbaseTableMetadata } from 'app/registries/dataset/couchbase-table-metadata';
import { db2TableMetadata } from 'app/registries/dataset/db2-table-metadata';
import { delimitedTextMetadata } from 'app/registries/dataset/delimitedtext-metadata';
import { documentDbCollectionMetadata } from 'app/registries/dataset/document-db-collection-metadata';
import { drillTableMetadata } from 'app/registries/dataset/drill-table-metadata';
import { dynamicsAXResourceMetadata } from 'app/registries/dataset/dynamics-ax-resource-metadata';
import { dynamicsCrmEntityMetadata } from 'app/registries/dataset/dynamics-crm-entity-metadata';
import { dynamicsEntityMetadata } from 'app/registries/dataset/dynamics-entity-metadata';
import { eloquaObjectMetadata } from 'app/registries/dataset/eloqua-object-metadata';
import { excelMetadata } from 'app/registries/dataset/excel-metadata';
import { fileShareDatasetMetadata } from 'app/registries/dataset/file-share-metadata';
import { googleAdWordsObjectMetadata } from 'app/registries/dataset/google-adwords-object-metadata';
import { googleBigQueryObjectMetadata } from 'app/registries/dataset/google-big-query-object-metadata';
import { greenplumTableMetadata } from 'app/registries/dataset/greenplum-table-metadata';
import { hBaseObjectMetadata } from 'app/registries/dataset/hbase-object-metadata';
import { hiveObjectMetadata } from 'app/registries/dataset/hive-object-metadata';
import { httpFileMetadata } from 'app/registries/dataset/http-file-metadata';
import { hubspotObjectMetadata } from 'app/registries/dataset/hubspot-object-metadata';
import { impalaObjectMetadata } from 'app/registries/dataset/impala-object-metadata';
import { informixTableMetadata } from 'app/registries/dataset/informix-table-metadata';
import { jiraObjectMetadata } from 'app/registries/dataset/jira-object-metadata';
import { attioObjectMetadata } from 'app/registries/dataset/attio-object-metadata';
import { bitbucketTableMetadata } from 'app/registries/dataset/bitbucket-table-metadata';
import { oracleFusionTableMetadata } from 'app/registries/dataset/oracle-fusion-table-metadata';
import { jsonMetadata } from 'app/registries/dataset/json-metadata';
import { kustoTableMetadata } from 'app/registries/dataset/kusto-table-metadata';
import { magentoObjectMetadata } from 'app/registries/dataset/magento-object-metadata';
import { mariaDBTableMetadata } from 'app/registries/dataset/maria-db-table-metadata';
import { marketoObjectMetadata } from 'app/registries/dataset/marketo-object-metadata';
import { microsoftAccessTableMetadata } from 'app/registries/dataset/microsoft-access-table-metadata';
import { mongoDbAtlasCollectionMetadata } from 'app/registries/dataset/mongo-db-atlas-collection-metadata';
import { mongoDbCollectionMetadata } from 'app/registries/dataset/mongo-db-collection-metadata';
import { mysqlTableMetadata } from 'app/registries/dataset/mysql-table-metadata';
import { nativeMongoDbCollectionMetadata } from 'app/registries/dataset/native-mongo-db-collection-metadata';
import { netezzaTableMetadata } from 'app/registries/dataset/netezza-table-metadata';
import { odataResourceMetadata } from 'app/registries/dataset/odata-resource-metadata';
import { odbcTableMetadata } from 'app/registries/dataset/odbc-table-metadata';
import { office365TableMetadata } from 'app/registries/dataset/office365-table-metadata';
import { oracleResponsysObjectMetadata } from 'app/registries/dataset/oracle-responsys-metadata';
import { oracleServiceCloudObjectMetadata } from 'app/registries/dataset/oracle-service-cloud-object-metadata';
import { oracleDatasetMetadata } from 'app/registries/dataset/oracle-table-metadata';
import { orcMetadata } from 'app/registries/dataset/orc-metadata';
import { parquetMetadata } from 'app/registries/dataset/parquet-metadata';
import { payPalObjectMetadata } from 'app/registries/dataset/paypal-object-metadata';
import { phoenixObjectMetadata } from 'app/registries/dataset/phoenix-object-metadata';
import { postgreSqlTableMetadata } from 'app/registries/dataset/postgre-sql-table-metadata';
import { prestoObjectMetadata } from 'app/registries/dataset/presto-object-metadata';
import { quickBooksObjectMetadata } from 'app/registries/dataset/quick-books-object-metadata';
import { relationalTableMetadata } from 'app/registries/dataset/relational-table-metadata';
import { restResourceMetadata } from 'app/registries/dataset/rest-resource-metadata';
import { salesforceMarketingCloudObjectMetadata } from 'app/registries/dataset/salesforce-marketing-cloud-object-metadata';
import { salesforceObjectMetadata } from 'app/registries/dataset/salesforce-object-metadata';
import { salesforceServiceCloudObjectMetadata } from 'app/registries/dataset/salesforce-service-cloud-object-metadata';
import { sapBwCubeMetadata } from 'app/registries/dataset/sap-bw-cube-metadata';
import { sapEccResourceMetadata } from 'app/registries/dataset/sap-ecc-resource-metadata';
import { sapOdpDatasetMetadata } from 'app/registries/dataset/sap-odp-dataset-metadata';
import { sapOpenHubTableMetadata } from 'app/registries/dataset/sap-open-hub-table-metadata';
import { sapTableResourceMetadata } from 'app/registries/dataset/sap-table-resource-metadata';
import { sapC4CResourceMetadata } from 'app/registries/dataset/sapc4c-resource-metadata';
import { sapHanaTableMetadata } from 'app/registries/dataset/saphana-table-metadata';
import { serviceNowObjectMetadata } from 'app/registries/dataset/servicenow-object-metadata';
import { sharePointOnlineListResourceMetadata } from 'app/registries/dataset/sharepoint-online-list-resource-metadata';
import { shopifyObjectMetadata } from 'app/registries/dataset/shopify-object-metadata';
import { snowflakeTableMetadata } from 'app/registries/dataset/snowflaketable-metadata';
import { sparkObjectMetadata } from 'app/registries/dataset/spark-object-metadata';
import { sqlServerDatasetMetadata } from 'app/registries/dataset/sqlserver-metadata';
import { squareObjectMetadata } from 'app/registries/dataset/square-object-metadata';
import { sybaseTableMetadata } from 'app/registries/dataset/sybase-table-metadata';
import { teradataTableMetadata } from 'app/registries/dataset/teradata-table-metadata';
import { verticaTableMetadata } from 'app/registries/dataset/vertica-table-metadata';
import { vivaInsightsReportMetadata } from 'app/registries/dataset/viva-insights-report-metadata';
import { webTableMetadata } from 'app/registries/dataset/webtable-metadata';
import { xeroObjectMetadata } from 'app/registries/dataset/xero-object-metadata';
import { xmlMetadata } from 'app/registries/dataset/xml-metadata';
import { zohoObjectMetadata } from 'app/registries/dataset/zoho-object-metadata';
import { adobeExperiencePlatformMetadata } from 'app/registries/linked-service/adobe-experience-platform-metadata';
import { adobeIntegrationMetadata } from 'app/registries/linked-service/adobe-integration-metadata';
import { amazonMWSMetadata } from 'app/registries/linked-service/amazon-mws-metadata';
import { amazonRdsForOracleMetadata } from 'app/registries/linked-service/amazon-rds-for-oracle-metadata';
import { amazonRdsSqlServerMetadata } from 'app/registries/linked-service/amazon-rds-sql-server-metadata';
import { amazonRedshiftMetadata } from 'app/registries/linked-service/amazon-redshift-metadata';
import { amazonS3CompatibleMetadata } from 'app/registries/linked-service/amazon-s3-compatible-metadata';
import { amazonS3Metadata } from 'app/registries/linked-service/amazon-s3-metadata';
import { azureBatchMetadata } from 'app/registries/linked-service/azure-batch-metadata';
import { azureBlobFSMetadata } from 'app/registries/linked-service/azure-blob-fs-metadata';
import { azureBlobStorageMetadata } from 'app/registries/linked-service/azure-blob-storage-metadata';
import { azureDataBricksMetadata } from 'app/registries/linked-service/azure-data-bricks-metadata';
import { azureDataExplorerMetadata } from 'app/registries/linked-service/azure-data-explorer-metadata';
import { azureDataLakeAnalyticsMetadata } from 'app/registries/linked-service/azure-data-lake-analytics-metadata';
import { azureDataLakeStoreCosmosStructuredStreamMetadata } from 'app/registries/linked-service/azure-data-lake-store-cosmos-structured-stream-metadata';
import { azureDataLakeStoreGen2CosmosStructuredStreamMetadata } from 'app/registries/linked-service/azure-data-lake-store-gen2-cosmos-structured-stream-metadata';
import { azureDataLakeStoreMetadata } from 'app/registries/linked-service/azure-data-lake-store-metadata';
import { azureDatabricksDeltaLakeMetadata } from 'app/registries/linked-service/azure-databricks-delta-lake-metadata';
import { databricksMetadata } from 'app/registries/linked-service/databricks-metadata';
import { azureFileStorageMetadata } from 'app/registries/linked-service/azure-file-storage-metadata';
import { azureFileStorageMetadataAdms } from 'app/registries/linked-service/azure-file-storage-metadata-adms';
import { azureFileStorageMetadataSsis } from 'app/registries/linked-service/azure-file-storage-metadata-ssis';
import { azureFunctionMetadata } from 'app/registries/linked-service/azure-function-metadata';
import { azureKeyVaultMetadata } from 'app/registries/linked-service/azure-key-vault-metadata';
import { azureMariaDBMetadata } from 'app/registries/linked-service/azure-maria-db-metadata';
import { azureMLMetadata } from 'app/registries/linked-service/azure-ml-metadata';
import { azureMLServiceMetadata } from 'app/registries/linked-service/azure-ml-service-metadata';
import { azureMySqlMetadata } from 'app/registries/linked-service/azure-mysql-metadata';
import { azurePostgreSqlMetadata } from 'app/registries/linked-service/azure-postgre-sql-metadata';
import { azureHorizonDbMetadata } from 'app/registries/linked-service/azure-horizon-db-metadata';
import { azureSearchMetadata } from 'app/registries/linked-service/azure-search-metadata';
import { azureSqlDWMetadata } from 'app/registries/linked-service/azure-sql-dw-metadata';
import { azureSqlMetadata } from 'app/registries/linked-service/azure-sql-metadata';
import { azureSqlMIMetadata } from 'app/registries/linked-service/azure-sql-mi-metadata';
import { azureStorageMetadata } from 'app/registries/linked-service/azure-storage-metadata';
import { azureTableStorageMetadata } from 'app/registries/linked-service/azure-table-storage-metadata';
import { cassandraMetadata } from 'app/registries/linked-service/cassandra-metadata';
import { commonDataServiceMetadata } from 'app/registries/linked-service/common-data-service-metadata';
import { concurMetadata } from 'app/registries/linked-service/concur-metadata';
import { cosmosDbMetadata } from 'app/registries/linked-service/cosmos-db-metadata';
import { cosmosDbMongoDbApiMetadata } from 'app/registries/linked-service/cosmos-db-mongodb-api-metadata';
import { couchbaseMetadata } from 'app/registries/linked-service/couchbase-metadata';
import { db2Metadata } from 'app/registries/linked-service/db2-metadata';
import { drillMetadata } from 'app/registries/linked-service/drill-metadata';
import { dynamicsAXMetadata } from 'app/registries/linked-service/dynamics-ax-metadata';
import { dynamicsCrmMetadata } from 'app/registries/linked-service/dynamics-crm-metadata';
import { dynamicsMetadata } from 'app/registries/linked-service/dynamics-metadata';
import { eloquaMetadata } from 'app/registries/linked-service/eloqua-metadata';
import { eventHubsMetadata } from 'app/registries/linked-service/event-hubs-metadata';
import { fileServerMetadata } from 'app/registries/linked-service/file-server-metadata';
import { ftpServerMetadata } from 'app/registries/linked-service/ftp-server-metadata';
import { gitHubMetadata } from 'app/registries/linked-service/github.metadata';
import { googleAdWordsMetadata } from 'app/registries/linked-service/google-adwords-metadata';
import { googleBigQueryMetadata } from 'app/registries/linked-service/google-bigquery-metadata';
import { googleCloudStorageMetadata } from 'app/registries/linked-service/google-cloud-storage-metadata';
import { greenplumMetadata } from 'app/registries/linked-service/greenplum-metadata';
import { hBaseMetadata } from 'app/registries/linked-service/hbase-metadata';
import { hdfsMetadata } from 'app/registries/linked-service/hdfs-metadata';
import { hdInsightMetadata } from 'app/registries/linked-service/hdinsight-metadata';
import { hdInsightOnDemandMetadata } from 'app/registries/linked-service/hdinsightondemand-metadata';
import { hiveMetadata } from 'app/registries/linked-service/hive-metadata';
import { httpServerMetadata } from 'app/registries/linked-service/http-server-metadata';
import { hubspotMetadata } from 'app/registries/linked-service/hubspot-metadata';
import { impalaMetadata } from 'app/registries/linked-service/impala-metadata';
import { informixMetadata } from 'app/registries/linked-service/informix-metadata';
import { jiraMetadata } from 'app/registries/linked-service/jira-metadata';
import { attioMetadata } from 'app/registries/linked-service/attio-metadata';
import { genericCDataMetadata } from 'app/registries/linked-service/generic-cdata-metadata';
import { bitbucketMetadata } from 'app/registries/linked-service/bitbucket-metadata';
import { oracleFusionMetadata } from 'app/registries/linked-service/oracle-fusion-metadata';
import { kustoMetadata } from 'app/registries/linked-service/kusto-metadata';
import { magentoMetadata } from 'app/registries/linked-service/magento-metadata';
import { mariaDBMetadata } from 'app/registries/linked-service/maria-db-metadata';
import { marketoMetadata } from 'app/registries/linked-service/marketo-metadata';
import { microsoftAccessMetadata } from 'app/registries/linked-service/microsoft-access-metadata';
import { mongoDbAtlasMetadata } from 'app/registries/linked-service/mongo-db-atlas-metadata';
import { mongoDbMetadata } from 'app/registries/linked-service/mongo-db-metadata';
import { mysqlMetadata } from 'app/registries/linked-service/mysql-metadata';
import { nativemongoDbMetadata } from 'app/registries/linked-service/native-mongo-db-metadata';
import { netezzaMetadata } from 'app/registries/linked-service/netezza-metadata';
import { oDataMetadata } from 'app/registries/linked-service/odata-metadata';
import { odbcMetadata } from 'app/registries/linked-service/odbc-metadata';
import { office365Metadata } from 'app/registries/linked-service/office365-metadata';
import { oracleCloudStorageMetadata } from 'app/registries/linked-service/oracle-cloud-storage-metadata';
import { oracleMetadata } from 'app/registries/linked-service/oracle-metadata';
import { oracleResponsysMetadata } from 'app/registries/linked-service/oracle-responsys-metadata';
import { oracleServiceCloudMetadata } from 'app/registries/linked-service/oracle-service-cloud-metadata';
import { paypalMetadata } from 'app/registries/linked-service/paypal-metadata';
import { phoenixMetadata } from 'app/registries/linked-service/phoenix-metadata';
import { postgreSqlMetadata } from 'app/registries/linked-service/postgre-sql-metadata';
import { prestoMetadata } from 'app/registries/linked-service/presto-metadata';
import { quickBooksMetadata } from 'app/registries/linked-service/quick-books-metadata';
import { quickbaseMetadata } from 'app/registries/linked-service/quickbase-metadata';
import { restServiceMetadata } from 'app/registries/linked-service/rest-service-metadata';
import { salesforceMarketingCloudMetadata } from 'app/registries/linked-service/salesforce-marketing-cloud-metadata';
import { salesforceMetadata } from 'app/registries/linked-service/salesforce-metadata';
import { salesforceServiceCloudMetadata } from 'app/registries/linked-service/salesforce-service-cloud-metadata';
import { sapBwMetadata } from 'app/registries/linked-service/sap-bw-metadata';
import { sapEccMetadata } from 'app/registries/linked-service/sap-ecc-metadata';
import { sapHanaMetadata } from 'app/registries/linked-service/sap-hana-metadata';
import { sapOdpMetadata } from 'app/registries/linked-service/sap-odp-metadata';
import { sapOpenHubMetadata } from 'app/registries/linked-service/sap-open-hub-metadata';
import { sapTableMetadata } from 'app/registries/linked-service/sap-table-metadata';
import { sapC4CMetadata } from 'app/registries/linked-service/sapc4c-metadata';
import { serviceNowMetadata } from 'app/registries/linked-service/servicenow-metadata';
import { sftpServerMetadata } from 'app/registries/linked-service/sftp-metadata';
import { sharePointOnlineFileMetadata } from 'app/registries/linked-service/sharepoint-online-file-metadata';
import { sharePointOnlineListMetadata } from 'app/registries/linked-service/sharepoint-online-list-metadata';
import { shopifyMetadata } from 'app/registries/linked-service/shopify-metadata';
import { smartsheetMetadata } from 'app/registries/linked-service/smartsheet-metadata';
import { snowflakeMetadata } from 'app/registries/linked-service/snowflake-metadata';
import { sparkMetadata } from 'app/registries/linked-service/spark-metadata';
import { sqlServerMetadata } from 'app/registries/linked-service/sql-server-metadata';
import { squareMetadata } from 'app/registries/linked-service/square-metadata';
import { sybaseMetadata } from 'app/registries/linked-service/sybase-metadata';
import { teamDeskMetadata } from 'app/registries/linked-service/team-desk-metadata';
import { teradataMetadata } from 'app/registries/linked-service/teradata-metadata';
import { verticaMetadata } from 'app/registries/linked-service/vertica-metadata';
import { vivaInsightsMetadata } from 'app/registries/linked-service/viva-insights-metadata';
import { webMetadata } from 'app/registries/linked-service/web-table-metadata';
import { workdayMetadata } from 'app/registries/linked-service/workday-metadata';
import { kafkaMetadata } from 'app/registries/linked-service/kafka-metadata';
import { xeroMetadata } from 'app/registries/linked-service/xero-metadata';
import { zendeskMetadata } from 'app/registries/linked-service/zendesk-metadata';
import { zohoMetadata } from 'app/registries/linked-service/zoho-metadata';
import { sqlPoolDatasetMetadata } from 'app/registries/dataset/sql-pool-dataset.metadata';
import { sqlPoolLinkedServiceMetadata } from 'app/registries/linked-service/sql-pool-connection-metadata';
import { powerBIWorkspaceMetadata } from 'app/registries/linked-service/power-bi-workspace-metadata';
import { cognitiveServiceMetaData } from 'app/registries/linked-service/cognitive-service-metadata';
import { IPrivateEndpointMetadata } from 'app/registries/private-endpoint/private-endpoint-metadata';
import { azureCognitiveServicesPrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-cognitive-services-metadata';
import { azureKeyVaultPrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-key-vault-metadata';
import { azureMariaDBPrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-mariadb-metadata';
import { azureMLPrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-ml-metadata';
import { azureMonitorPrivateLinkScopePrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-monitor-private-link-scope-metadata';
import { azureMySQLPrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-mysql-metadata';
import { azurePostgreSQLPrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-postgresql-metadata';
import { azureSearchPrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-search-metadata';
import { azureStoragePrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-storage-metadata';
import { babylonPrivateEndpointMetadata } from 'app/registries/private-endpoint/babylon-pe-metadata';
import { azureCosmosDBPrivateEndpointMetadata } from 'app/registries/private-endpoint/cosmos-db-metadata';
import { privateLinkServiceMetadata } from 'app/registries/private-endpoint/private-link-service-metadata';
import { sqlMIPrivateEndpointMetadata } from 'app/registries/private-endpoint/sql-mi-metadata';
import { sqlServerPrivateEndpointMetadata } from 'app/registries/private-endpoint/sql-server-metadata';
import { synapseWorkspacePrivateEndpointMetadata } from 'app/registries/private-endpoint/synapse-workspace-metadata';
import { PrivateEndpointRegistryService } from 'app/registries/private-endpoint/private-endpoint-registry.service';
import { azureDataExplorerPEMetadata } from 'app/registries/private-endpoint/azure-data-explorer-metadata';
import { azureFunctionPEMetadata } from 'app/registries/private-endpoint/azure-function-metadata';
import { azureSynapsePrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-synapse-artifacts-metadata';
import { azureSynapseArtifactsMetadata } from 'app/registries/linked-service/azure-synapse-artifacts-metadata';
import { lakehouseMetadata } from 'app/registries/linked-service/lakehouse-metadata';
import { mountedRelationalDatabaseMetadata } from 'app/registries/linked-service/mounted-relational-database-metadata';
import { sapCdcDatasetMetadata } from 'app/registries/dataset/sap-cdc-dataset-metadata';
import { sapBdcDatasetMetadata } from 'app/registries/dataset/sap-bdc-dataset-metadata';
import { sapCdcMetadata } from 'app/registries/linked-service/sap-cdc-metadata';
import { sapBdcMetadata } from 'app/registries/linked-service/sap-bdc-metadata';
import { deltaMetadata } from 'app/registries/dataset/delta-metadata';
import { appGatewayPrivateEndpointMetadata } from 'app/registries/private-endpoint/application-gateway-metadata';
import { trinoMetadata } from 'app/registries/linked-service/trino-metadata';
import { trinoDatasetMetadata } from 'app/registries/dataset/trino-metadata';
import { azureDatabricksMetadata } from 'app/registries/private-endpoint/azure-databricks-metadata';
import { kustoDatabaseMetadata } from 'app/registries/linked-service/kusto-database-metadata';
import { kustoDatabaseTableMetadata } from 'app/registries/dataset/kusto-database-table-metadata';
import { dataWarehouseMetadata } from 'app/registries/linked-service/data-warehouse-metadata';
import { dataWarehouseTableDatasetMetadata } from 'app/registries/dataset/data-warehouse-table-metadata';
import { lakehouseTableMetadata } from 'app/registries/dataset/lakehouse-table-metadata';
import { eventHubsDatasetMetadata } from 'app/registries/dataset/event-hubs-metadata';
import { eventStreamDatasetMetadata } from 'app/registries/dataset/event-stream-dataset-metadata';
import { sapODataMetadata } from 'app/registries/linked-service/sap-odata-metadata';
import { sapODataDatasetMetadata } from 'app/registries/dataset/sap-odata-dataset-metadata';
import { kafkaDatasetMetadata } from 'app/registries/dataset/kafka-metadata';
import { webActivityMetadata } from 'app/registries/linked-service/web-activity-metadata';
import { powerBIMetadata } from 'app/registries/linked-service/powerbi-metadata';
import { azureEventHubPrivateEndpointMetadata } from 'app/registries/private-endpoint/azure-event-hubs-metadata';
import { isFunction } from 'lodash';
import { azureDataFactoryMetadata } from 'app/registries/linked-service/azure-data-factory-metadata';
import { azureSynapseAnalyticsMetadata } from 'app/registries/linked-service/azure-synapse-analytics-metadata';
import { fabricMetadata } from 'app/registries/linked-service/fabric-workspace-metadata';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';
import { type EnvironmentInjector } from '@angular/core';
import { salesforceV2Metadata } from 'app/registries/linked-service/salesforce-v2-metadata';
import { salesforceServiceCloudV2Metadata } from 'app/registries/linked-service/salesforce-service-cloud-v2-metadata';
import { salesforceV2ObjectMetadata } from 'app/registries/dataset/salesforce-v2-object-metadata';
import { salesforceServiceCloudV2ObjectMetadata } from 'app/registries/dataset/salesforce-service-cloud-v2-object-metadata';
import { snowflakeV2Metadata } from 'app/registries/linked-service/snowflake-v2-metadata';
import { snowflakeV2TableMetadata } from 'app/registries/dataset/snowflake-v2-table-metadata';
import { googleBigQueryV2Metadata } from 'app/registries/linked-service/google-bigquery-v2-metadata';
import { googleBigQueryObjectV2Metadata } from 'app/registries/dataset/google-big-query-object-v2-metadata';
import { postgreSqlV2Metadata } from 'app/registries/linked-service/postgre-sql-v2-metadata';
import { postgreSqlTableV2Metadata } from 'app/registries/dataset/postgre-sql-table-v2-metadata';
import { serviceNowV2Metadata } from 'app/registries/linked-service/servicenow-v2-metadata';
import { serviceNowV2ObjectMetadata } from 'app/registries/dataset/servicenow-v2-object-metadata';
import { fabricDataPipelinesMetadata } from 'app/registries/linked-service/fabric-data-pipelines-metadata';
import { microsoftTeamsMetadata } from 'app/registries/linked-service/microsoft-teams-metadata';
import { fabricSqlMetadata } from 'app/registries/linked-service/fabric-sql-metadata';
import { fabricSqlTableDatasetMetadata } from 'app/registries/dataset/fabric-sql-table-metadata';
import { tridentSparkJobDefinitionMetadata } from 'app/registries/linked-service/trident-sparkjobdefinition-metadata';
import { fabricNotebookMetadata } from 'app/registries/linked-service/fabric-notebook-metadata';
import { fabricAirflowMetadata } from 'app/registries/linked-service/fabric-airflow-metadata';
import { fabricUserDataFunctionsMetadata } from 'app/registries/linked-service/fabric-userdatafunctions-metadata';
import { fabricDataflowMetadata } from 'app/registries/linked-service/fabric-dataflow-metadata';
import { mountedRelationalDatabaseDatasetMetadata } from 'app/registries/dataset/mounted-relational-database-dataset.metadata';
import { invokeCopyJobMetadata } from 'app/registries/linked-service/invoke-copyjob-metadata';
import { sqlAnalyticsEndpointMetadata } from 'app/registries/linked-service/sql-analytics-endpoint-metadata';
import { sqlAnalyticsEndpointDatasetMetadata } from 'app/registries/dataset/sql-analytics-endpoint-metadata';
import { office365EmailMetadata } from 'app/registries/linked-service/office365-email-metadata';
import { sapDatasphereForAzureDataLakeStorageGen2Metadata } from 'app/registries/linked-service/sap-datasphere-for-azure-data-lake-storage-gen2-metadata';
import { oneLakeFileMetadata } from 'app/registries/linked-service/one-lake-file-metadata';
import { sapDatasphereForGoogleCloudStorageMetadata } from 'app/registries/linked-service/sap-datasphere-for-google-cloud-storage-metadata';
import { sapDatasphereForAmazonS3Metadata } from 'app/registries/linked-service/sap-datasphere-for-amazon-s3-metadata';
import { fabricSqlEndpointMetadata } from 'app/registries/linked-service/fabric-sql-endpoint-metadata';
import { fmlvMetadata } from 'app/registries/linked-service/fmlv-metadata';
import { dataBuildToolJobMetadata } from 'app/registries/linked-service/data-build-tool-job-metadata';
import { dataQualityMetadata } from 'app/registries/linked-service/data-quality-metadata';
import { eventStreamMetadata } from 'app/registries/linked-service/event-stream-metadata';


const lsMetadata: Array<IDynamicLinkedServiceTypeMetadata | ILinkedServiceTypeMetadata> = [
    // computed
    hdInsightOnDemandMetadata,
    hdInsightMetadata,
    azureDataLakeAnalyticsMetadata,
    azureBatchMetadata,
    azureFunctionMetadata,
    azureMLMetadata,
    azureMLServiceMetadata,
    azureSynapseArtifactsMetadata,

    // first class
    azureStorageMetadata,
    azureBlobStorageMetadata,
    azureTableStorageMetadata,
    amazonS3Metadata,
    amazonS3CompatibleMetadata,
    oracleCloudStorageMetadata,
    amazonRedshiftMetadata,
    azureSqlDWMetadata,
    azureSqlMetadata,
    sqlServerMetadata,
    azureSqlMIMetadata,
    azureDataLakeStoreMetadata,
    azureDataLakeStoreCosmosStructuredStreamMetadata,
    azureDataLakeStoreGen2CosmosStructuredStreamMetadata,
    oracleMetadata,
    fileServerMetadata,
    lakehouseMetadata,
    mountedRelationalDatabaseMetadata,
    salesforceMetadata,
    salesforceV2Metadata,
    azureKeyVaultMetadata,
    mysqlMetadata,
    odbcMetadata,
    sapBwMetadata,
    sapHanaMetadata,
    hdfsMetadata,
    azureMySqlMetadata,
    azurePostgreSqlMetadata,
    // Backend not ready: only expose the native HorizonDB copy connector when the flag is on.
    ...(GlobalVariables.enableAzureHorizonDb ? [azureHorizonDbMetadata] : []),
    cosmosDbMetadata,
    azureSearchMetadata,
    db2Metadata,
    mongoDbMetadata,
    ftpServerMetadata,
    sftpServerMetadata,
    cassandraMetadata,
    sybaseMetadata,
    teradataMetadata,
    postgreSqlMetadata,
    postgreSqlV2Metadata,
    googleBigQueryMetadata,
    googleBigQueryV2Metadata,
    impalaMetadata,
    serviceNowMetadata,
    serviceNowV2Metadata,
    oDataMetadata,
    httpServerMetadata,
    office365Metadata,
    dynamicsMetadata,
    azureDataBricksMetadata,
    amazonMWSMetadata,
    azureBlobFSMetadata,
    oneLakeFileMetadata,
    sapDatasphereForAzureDataLakeStorageGen2Metadata,
    sapDatasphereForGoogleCloudStorageMetadata,
    sapDatasphereForAmazonS3Metadata,
    sapC4CMetadata,
    sapEccMetadata,
    hBaseMetadata,
    hiveMetadata,
    kustoMetadata,
    sparkMetadata,
    phoenixMetadata,
    paypalMetadata,
    marketoMetadata,
    oracleResponsysMetadata,
    salesforceMarketingCloudMetadata,
    prestoMetadata,
    squareMetadata,
    xeroMetadata,
    jiraMetadata,
    genericCDataMetadata,
    attioMetadata,
    bitbucketMetadata,
    oracleFusionMetadata,
    magentoMetadata,
    shopifyMetadata,
    concurMetadata,
    hubspotMetadata,
    zohoMetadata,
    eloquaMetadata,
    quickBooksMetadata,
    webMetadata,
    couchbaseMetadata,
    drillMetadata,
    greenplumMetadata,
    mariaDBMetadata,
    netezzaMetadata,
    verticaMetadata,
    vivaInsightsMetadata,
    nativemongoDbMetadata,
    cosmosDbMongoDbApiMetadata,
    oracleServiceCloudMetadata,
    googleAdWordsMetadata,
    restServiceMetadata,
    snowflakeMetadata,
    snowflakeV2Metadata,
    dynamicsAXMetadata,
    sapOpenHubMetadata,
    azureDataExplorerMetadata,
    kustoDatabaseMetadata,
    dataWarehouseMetadata,
    fabricSqlMetadata,
    sqlAnalyticsEndpointMetadata,
    sapTableMetadata,
    adobeExperiencePlatformMetadata,
    adobeIntegrationMetadata,
    dynamicsCrmMetadata,
    commonDataServiceMetadata,
    salesforceServiceCloudMetadata,
    salesforceServiceCloudV2Metadata,
    informixMetadata,
    microsoftAccessMetadata,
    azureMariaDBMetadata,
    azureFileStorageMetadata,
    azureFileStorageMetadataSsis,
    azureFileStorageMetadataAdms,
    googleCloudStorageMetadata,
    gitHubMetadata,
    azureDatabricksDeltaLakeMetadata,
    databricksMetadata,
    sharePointOnlineListMetadata,
    sharePointOnlineFileMetadata,
    mongoDbAtlasMetadata,
    amazonRdsForOracleMetadata,
    amazonRdsSqlServerMetadata,
    eventHubsMetadata,
    kafkaMetadata,
    sapOdpMetadata,
    sapCdcMetadata,
    sapBdcMetadata,
    sapODataMetadata,
    teamDeskMetadata,
    quickbaseMetadata,
    smartsheetMetadata,
    zendeskMetadata,
    workdayMetadata,
    webActivityMetadata
];

const dsMetadata: Array<IDynamicDatasetTypeMetadata | IDatasetTypeMetadata> = [
    // first class
    azureBlobDatasetMetadata,
    amazonS3DatasetMetadata,
    azureBlobFSDatasetMetadata,
    azureSqlDWDatasetMetadata,
    dataWarehouseTableDatasetMetadata,
    azureSqlDatasetMetadata,
    fabricSqlTableDatasetMetadata,
    sqlAnalyticsEndpointDatasetMetadata,
    sqlServerDatasetMetadata,
    azureSqlMITableMetadata,
    oracleDatasetMetadata,
    azureDataLakeStoreFileDatasetMetadata,
    azureDataLakeStoreCosmosStructuredStreamFileDatasetMetadata,
    azureDataLakeStoreGen2CosmosStructuredStreamFileDatasetMetadata,
    fileShareDatasetMetadata,
    salesforceObjectMetadata,
    salesforceV2ObjectMetadata,
    relationalTableMetadata,
    genericCDataTableMetadata,
    odataResourceMetadata,
    azureMySqlTableMetadata,
    mountedRelationalDatabaseDatasetMetadata,
    azurePostgreSqlTableMetadata,
    // Backend not ready: only expose the native HorizonDB copy connector when the flag is on.
    ...(GlobalVariables.enableAzureHorizonDb ? [azureHorizonDbTableMetadata] : []),
    azureTableMetadata,
    cosmosDbCollectionMetadata,
    documentDbCollectionMetadata,
    azureSearchIndexMetadata,
    mongoDbCollectionMetadata,
    googleBigQueryObjectMetadata,
    googleBigQueryObjectV2Metadata,
    impalaObjectMetadata,
    cassandraTableMetadata,
    serviceNowObjectMetadata,
    serviceNowV2ObjectMetadata,
    office365TableMetadata,
    odbcTableMetadata,
    dynamicsEntityMetadata,
    httpFileMetadata,
    amazonMWSObjectMetadata,
    amazonRedshiftTableMetadata,
    sapC4CResourceMetadata,
    sapEccResourceMetadata,
    hBaseObjectMetadata,
    hiveObjectMetadata,
    eventHubsDatasetMetadata,
    kafkaDatasetMetadata,
    kustoTableMetadata,
    sparkObjectMetadata,
    phoenixObjectMetadata,
    payPalObjectMetadata,
    marketoObjectMetadata,
    oracleResponsysObjectMetadata,
    salesforceMarketingCloudObjectMetadata,
    prestoObjectMetadata,
    xeroObjectMetadata,
    squareObjectMetadata,
    magentoObjectMetadata,
    shopifyObjectMetadata,
    jiraObjectMetadata,
    attioObjectMetadata,
    bitbucketTableMetadata,
    oracleFusionTableMetadata,
    concurObjectMetadata,
    hubspotObjectMetadata,
    quickBooksObjectMetadata,
    eloquaObjectMetadata,
    zohoObjectMetadata,
    webTableMetadata,
    couchbaseTableMetadata,
    drillTableMetadata,
    greenplumTableMetadata,
    mariaDBTableMetadata,
    teradataTableMetadata,
    db2TableMetadata,
    postgreSqlTableMetadata,
    postgreSqlTableV2Metadata,
    netezzaTableMetadata,
    verticaTableMetadata,
    vivaInsightsReportMetadata,
    nativeMongoDbCollectionMetadata,
    cosmosDbMongoDbApiCollectionMetadata,
    oracleServiceCloudObjectMetadata,
    googleAdWordsObjectMetadata,
    restResourceMetadata,
    snowflakeTableMetadata,
    snowflakeV2TableMetadata,
    sapTableResourceMetadata,
    sapOpenHubTableMetadata,
    dynamicsAXResourceMetadata,
    parquetMetadata,
    jsonMetadata,
    avroMetadata,
    orcMetadata,
    deltaMetadata,
    delimitedTextMetadata,
    excelMetadata,
    azureDataExplorerTableMetadata,
    kustoDatabaseTableMetadata,
    binaryMetadata,
    xmlMetadata,
    adobeExperiencePlatformDatasetMetadata,
    sapHanaTableMetadata,
    sybaseTableMetadata,
    sapBwCubeMetadata,
    azureMariaDBTableMetadata,
    microsoftAccessTableMetadata,
    informixTableMetadata,
    salesforceServiceCloudObjectMetadata,
    salesforceServiceCloudV2ObjectMetadata,
    commonDataServiceEntityMetadata,
    dynamicsCrmEntityMetadata,
    mysqlTableMetadata,
    sharePointOnlineListResourceMetadata,
    azureDatabricksDeltaLakeDatasetMetadata,
    databricksDatasetMetadata,
    mongoDbAtlasCollectionMetadata,
    amazonRdsForOracleDatasetMetadata,
    amazonRdsSqlServerDatasetMetadata,
    sapOdpDatasetMetadata,
    sapCdcDatasetMetadata,
    sapBdcDatasetMetadata,
    sapODataDatasetMetadata,
    lakehouseTableMetadata
];

const peMetadata: IPrivateEndpointMetadata[] = [
    azureStoragePrivateEndpointMetadata,
    synapseWorkspacePrivateEndpointMetadata,
    azureSearchPrivateEndpointMetadata,
    azureMySQLPrivateEndpointMetadata,
    azurePostgreSQLPrivateEndpointMetadata,
    azureMariaDBPrivateEndpointMetadata,
    azureCosmosDBPrivateEndpointMetadata,
    azureKeyVaultPrivateEndpointMetadata,
    azureCognitiveServicesPrivateEndpointMetadata,
    azureMLPrivateEndpointMetadata,
    sqlServerPrivateEndpointMetadata,
    privateLinkServiceMetadata,
    babylonPrivateEndpointMetadata,
    sqlMIPrivateEndpointMetadata,
    azureDatabricksMetadata,
    azureSynapsePrivateEndpointMetadata,
    azureDataExplorerPEMetadata,
    azureFunctionPEMetadata,
    appGatewayPrivateEndpointMetadata
];

export async function initializeLinkedServiceMetadata(injector: EnvironmentInjector): Promise<void> {
    const result: ILinkedServiceTypeMetadata[] = await Promise.all(
        lsMetadata.map((metadata) => (isFunction(metadata) ? metadata(injector) : metadata))
    );
    if (__IS_A365__) {
        result.push(powerBIWorkspaceMetadata);
        result.push(sqlPoolLinkedServiceMetadata); // this is a fake metadata for sql compute
        result.push(cognitiveServiceMetaData);
    }

    const ecService = await getServiceInstance<ExposureControlService>(injector, 'ExposureControlService');
    if (ecService.enableTrino) {
        result.push(trinoMetadata);
    }

    if (GlobalVariables.microsoftTeams) {
        result.push(microsoftTeamsMetadata);
    }

    if (__IS_FABRIC_DPE__ || __IS_FABRIC_MDF__) {
        result.push(await powerBIMetadata(injector));
        result.push(await fabricNotebookMetadata(injector));
        result.push(await fabricAirflowMetadata(injector));
        result.push(await tridentSparkJobDefinitionMetadata(injector));
        result.push(await fabricUserDataFunctionsMetadata(injector));
        result.push(await fabricDataflowMetadata(injector));
        result.push(await invokeCopyJobMetadata(injector));
        result.push(await office365EmailMetadata(injector));
        result.push(await azureDataFactoryMetadata(injector));
        result.push(await azureSynapseAnalyticsMetadata(injector));
        result.push(fabricMetadata);
        result.push(await fabricDataPipelinesMetadata(injector));
        result.push(await fabricSqlEndpointMetadata(injector));
        result.push(await fmlvMetadata(injector));
        result.push(await dataBuildToolJobMetadata(injector));
        result.push(await dataQualityMetadata(injector));
        result.push(await eventStreamMetadata(injector));
    }

    injector.get(LinkedServiceDynamicLoaderService).initialize(result);
}

async function initializeDatasetMetadata(injector: EnvironmentInjector): Promise<void> {
    const result: IDatasetTypeMetadata[] = await Promise.all(
        dsMetadata.map((metadata) => (isFunction(metadata) ? metadata(injector) : metadata))
    );
    if (__IS_A365__) {
        result.push(sqlPoolDatasetMetadata);
    }
    const enableTrino = (await getServiceInstance<ExposureControlService>(injector, 'ExposureControlService'))
        .enableTrino;
    if (enableTrino) {
        result.push(trinoDatasetMetadata);
    }

    result.push(icebergMetadata);

    if (__IS_FABRIC_DPE__ || __IS_FABRIC_MDF__) {
        result.push(eventStreamDatasetMetadata);
    }

    injector.get(DatasetDynamicLoaderService).initialize(result);
}

async function initializePEMetadata(injector: EnvironmentInjector): Promise<void> {
    const result = [...peMetadata];

    if (__IS_A365__) {
        result.push(azureMonitorPrivateLinkScopePrivateEndpointMetadata);
    }
    if (GlobalVariables.enableEventHubsPE) {
        result.push(azureEventHubPrivateEndpointMetadata);
    }

    injector.get(PrivateEndpointRegistryService).initialize(result);
}

export async function initializeDatasetLinkedServiceMetadata(injector: EnvironmentInjector): Promise<void> {
    await initializeLinkedServiceMetadata(injector);
    await initializeDatasetMetadata(injector);
}

export async function initializeMetadata(injector: EnvironmentInjector): Promise<void> {
    await initializeDatasetLinkedServiceMetadata(injector);
    injector.get(DataflowFormatDynamicLoaderService).initialize();
    await initializePEMetadata(injector);
}
